import type { ReactNode } from 'react';
import clsx from 'clsx';

export function Eyebrow({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p className={clsx('m-0 mb-3 font-mono text-[0.75rem] tracking-[0.08em] text-teal-700 uppercase', className)}>
      {children}
    </p>
  );
}
